import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useBranch from 'client/hooks/useBranch';
import { makeProxiedS3FilePath } from 'client/lib/fileUploader';

import SrBox from 'client/components/SrBox';

const SrS3FileDisplay = ({ url, maxWidth, maxHeight, withRotateButton }) => {
  const [rotationDegrees, setRotationDegrees] = useState(0);
  const { appUrl } = useBranch({
    appUrl: ['env', 'APP_URL'],
  });

  const proxiedS3FilePath = makeProxiedS3FilePath(url, appUrl);
  // TODO(@d-oliveros): Render <img> only if has a valid image extension.
  if (!proxiedS3FilePath.toLowerCase().includes('.pdf')) {
    const imageStyle = {
      maxHeight,
      maxWidth,
    };

    if (rotationDegrees) {
      imageStyle.transform = `rotate(${rotationDegrees}deg)`;
    }

    const onRotateButtonClick = () => {
      setRotationDegrees(rotationDegrees + 90);
    };
    return (
      <SrBox position="relative">
        <img src={proxiedS3FilePath} alt={proxiedS3FilePath} style={imageStyle} />
        {withRotateButton && (
          <div className="rotateButton" onClick={onRotateButtonClick}>
            rotate
          </div>
        )}
      </SrBox>
    );
  }

  if (proxiedS3FilePath.toLowerCase().includes('.pdf')) {
    if (!global.navigator?.pdfViewerEnabled) {
      // The browser does not support inline viewing of PDF files.
      return <span>The browser does not support inline viewing of PDF files.</span>;
    }

    return (
      <iframe
        title={proxiedS3FilePath}
        src={`/pdf-viewer?pdfUrl=${proxiedS3FilePath}`}
        style={{ width: maxWidth || '75vw', height: maxHeight || '700px' }}
      />
    );
  }

  return <span>{`Unsupported file extension: ${proxiedS3FilePath}`}</span>;
};

SrS3FileDisplay.propTypes = {
  url: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  withRotateButton: PropTypes.bool,
};

SrS3FileDisplay.defaultProps = {
  maxWidth: '100%',
  maxHeight: '100%',
};

SrS3FileDisplay.displayName = 'SrS3FileDisplay';

export default SrS3FileDisplay;
